"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const smap_1 = require("../smap");
const recipeValues_1 = __importDefault(require("./recipeValues"));
const hideOnBuy = [
    ...(0, smap_1.keys)(recipeValues_1.default.recipes).filter((x) => x.startsWith("research-")),
    "begin",
];
exports.default = {
    hideOnBuy,
};
